import React from 'react'

import influencerData from '../../data-influencer/ursula'
import PageBuilder from '../PageBuilder'
import PageLayout from './PageLayout'

const Ursula = () => (
    <PageBuilder influencerData={influencerData}>
        <PageLayout />
    </PageBuilder>
)

export default Ursula
